(function () {
  const hydrateLazyLocalization = (root = document) => {
    root
      .querySelectorAll("template[data-lazy-localization-template]")
      .forEach((template) => {
        if (template.dataset.lazyLocalizationBound) return;
        template.dataset.lazyLocalizationBound = "true";

        const details = template.closest("details");
        const target = template.parentElement?.querySelector(
          "[data-lazy-localization-target]"
        );
        if (!details || !target) return;

        const hydrate = () => {
          if (!template.isConnected || target.childElementCount > 0) return;
          target.append(template.content.cloneNode(true));
          template.remove();
        };

        details.addEventListener("toggle", () => {
          if (details.open) hydrate();
        });
        details.querySelector("summary")?.addEventListener("pointerenter", hydrate, {
          once: true,
        });
        details.querySelector("summary")?.addEventListener("focusin", hydrate, {
          once: true,
        });
      });
  };

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const headerAlways = document.querySelector(".header-always");
    const stickyHeader = document.querySelector("sticky-header");
    const stickyHeaderBackgroundColorScheme = stickyHeader.dataset.backgroundColorScheme;

    if (headerAlways) {
      header.classList.add("always-show");
    }

    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector(".header__search");

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty(
          "--ann-height",
          `${entry.intersectionRect.height}px`
        );
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });
    if (annBar) annBarObserver.observe(annBar);

    //menuLinks &&
    //	menuLinks.forEach((link) => {
    //		link.addEventListener("mouseenter", (e) => {
    //			if (link.classList.contains("list-menu--megamenu")) {
    //				link.classList.add("list-menu--megamenu-visible");
    //				if (
    //					header.classList.contains("color-background-2") &&
    //					!header.classList.contains("shopify-section-header-sticky")
    //				) {
    //					header.classList.remove("color-background-2");
    //				}

    //				menuLinks.forEach((el) => {
    //					if (el !== link) {
    //						el.classList.remove("list-menu--megamenu-visible");
    //					}
    //				});
    //			} else {
    //				menuLinks.forEach((el) => {
    //					el.classList.remove("list-menu--megamenu-visible");
    //				});
    //			}
    //		});
    //	});
    //menu &&
    //	menu.addEventListener("mouseleave", (e) => {
    //		menuLinks.forEach((link) => {
    //			link.classList.remove("list-menu--megamenu-visible");
    //		});
    //	});

    const addBackground = () => {
      if (document.querySelector(".overflow-hidden-drawer")) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry.contentRect.width >= 1100) {
          if (
            header.classList.contains("color-background-2") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            header.classList.remove("color-background-2");
          }

          if (
            header.classList.contains("section--has-overlay") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            header.classList.add("have-background");
          }
        }
      });

      headerObserver.observe(header);
    };

    const removeBackground = () => {
      if (
        document.querySelector(".overflow-hidden") ||
        document.querySelector(".overflow-hidden-drawer")
      ) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry.contentRect.width >= 1100) {
          if (
            header.classList.contains(stickyHeaderBackgroundColorScheme) &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            header.classList.add("color-background-2");
          }

          if (
            header.classList.contains("section--has-overlay") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            header.classList.remove("have-background");
          }
        }
      });

      headerObserver.observe(header);
    };

    header.addEventListener("mouseenter", addBackground);

    header.addEventListener("focus", addBackground);

    header.addEventListener("focusin", addBackground);

    header.addEventListener("mouseleave", removeBackground);

    header.addEventListener("focusout", removeBackground);

    document.addEventListener("DOMContentLoaded", () => {
      const firstSection = document.querySelector(
        "main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)"
      );
      let isSectionVisible = false;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !isSectionVisible) {
            isSectionVisible = true;
            header.classList.add("entering-section", "color-background-2");
          } else if (!entry.isIntersecting && isSectionVisible) {
            isSectionVisible = false;
            header.classList.remove("entering-section");
          }
        },
        { threshold: 0.15 }
      );

      if (firstSection) {
        observer.observe(firstSection);
      }

      window.addEventListener("scroll", () => {
        if (isSectionVisible) {
          header.classList.add("entering-section", "color-background-2");
        }
      });
    });

    //const megaMenuListLinks = () => {
    //	const megaMenuLinkWithSubmenu = document.querySelector(
    //		".mega-menu__list-item--children"
    //	);
    //	const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
    //	if (megaMenuLinkWithSubmenu) {
    //		megaMenuLinks.forEach((link) => {
    //			link.classList.add("mega-menu__list-item--opacity");
    //		});
    //		megaMenuLinkWithSubmenu.classList.remove(
    //			"mega-menu__list-item--opacity"
    //		);
    //		megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
    //	}
    //	$(".mega-menu__list-item").mouseenter(function (event) {
    //		if (megaMenuLinkWithSubmenu) {
    //			megaMenuLinkWithSubmenu.classList.remove(
    //				"mega-menu__list-item--visible"
    //			);
    //		}
    //		$(this).removeClass("mega-menu__list-item--opacity");
    //		$(this).siblings().addClass("mega-menu__list-item--opacity");
    //		$(this).mouseleave(() => {
    //			$(this).siblings().removeClass("mega-menu__list-item--opacity");
    //		});
    //	});
    //	$(".mega-menu__list-item").focus(function (event) {
    //		if (megaMenuLinkWithSubmenu) {
    //			megaMenuLinkWithSubmenu.classList.remove(
    //				"mega-menu__list-item--visible"
    //			);
    //		}
    //		$(this).removeClass("mega-menu__list-item--opacity");
    //		$(this).siblings().addClass("mega-menu__list-item--opacity");
    //		$(this).mouseleave(() => {
    //			$(this).siblings().removeClass("mega-menu__list-item--opacity");
    //		});
    //	});
    //};

    //const megaMenuSublinks = () => {
    //	$(".mega-menu--list .mega-menu__submenu-item").mouseenter(function (
    //		event
    //	) {
    //		$(this).removeClass("mega-menu__submenu-item--opacity");
    //		$(this)
    //			.parent()
    //			.siblings()
    //			.find(".mega-menu__submenu-item")
    //			.addClass("mega-menu__submenu-item--opacity");
    //		$(this).mouseleave(() => {
    //			$(this)
    //				.parent()
    //				.siblings()
    //				.find(".mega-menu__submenu-item")
    //				.removeClass("mega-menu__submenu-item--opacity");
    //		});
    //	});
    //	$(".mega-menu--list .mega-menu__submenu-item").focusin(function (event) {
    //		$(this).removeClass("mega-menu__submenu-item--opacity");
    //		$(this)
    //			.parent()
    //			.siblings()
    //			.find(".mega-menu__submenu-item")
    //			.addClass("mega-menu__submenu-item--opacity");
    //		$(this).focusout(() => {
    //			$(this)
    //				.parent()
    //				.siblings()
    //				.find(".mega-menu__submenu-item")
    //				.removeClass("mega-menu__submenu-item--opacity");
    //		});
    //	});
    //};
    //megaMenuListLinks();
    //megaMenuSublinks();

    const initSubmenuMedia = () => {
      document
        .querySelectorAll(".header__submenu--with-media")
        .forEach((submenu) => {
          if (submenu.dataset.submenuMediaBound) return;
          submenu.dataset.submenuMediaBound = "true";

          const media = submenu.querySelector("[data-submenu-media]");
          const image = submenu.querySelector("[data-submenu-media-image]");
          if (!media || !image) return;

          const showImage = (link) => {
            const src = link.dataset.submenuMediaSrc;
            if (!src) {
              media.classList.add("is-hidden");
              return;
            }
            image.src = src;
            image.alt = link.dataset.submenuMediaAlt || "";
            media.classList.remove("is-hidden");
          };

          const hideImage = () => {
            media.classList.add("is-hidden");
          };

          submenu
            .querySelectorAll("[data-submenu-media-link]")
            .forEach((link) => {
              link.addEventListener("mouseenter", () => showImage(link));
              link.addEventListener("focus", () => showImage(link));
            });

          const menuItem = submenu.closest(".list-menu-item");
          if (menuItem) {
            menuItem.addEventListener("mouseleave", hideImage);
            menuItem.addEventListener("focusout", (e) => {
              if (!menuItem.contains(e.relatedTarget)) hideImage();
            });
          }
        });
    };

    initSubmenuMedia();
    hydrateLazyLocalization(header);

    const main = document.querySelector("main");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    if (
      main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("section--has-overlay") &&
      !main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("not-margin")
    ) {
      header.classList.add(stickyHeaderBackgroundColorScheme, "color-background-2");
      if (breadcrumbs) {
        breadcrumbs.classList.add("color-background-2");
      }
    }
  };

  header();
  hydrateLazyLocalization(document);

  document.addEventListener("leposse:menu-drawer-hydrated", (event) => {
    hydrateLazyLocalization(event.detail?.root || document);
  });

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);
})();
